import React from "react";
import Banner from "../../Components/userComponents/Common/Banner";
import ContactDetails from "../../Components/userComponents/ContactComponents/ContactDetails";
import ContactUsMapContainer from "../../Components/userComponents/ContactComponents/ContactUsMapContainer";
import ContactForm from "../../Components/userComponents/ContactComponents/ContactForm";

const Contact = () => {
  return (
    <div>
      <Banner page="Contact Us" path="contact" />
      <ContactDetails />
      <ContactUsMapContainer />
      <ContactForm />
    </div>
  );
};

export default Contact;
